import { DEFAULT_PROTO, DEFAULT_DOMAIN, customHeaders } from "shared/constants/requestHeaders";
import { PAYMENT_FLOWS } from "constants/payment";


const getUrlWithoutQueryString = (str: string) => {
  try {
    let occurrence = str.indexOf("?");
    let urlWithoutQueryString = "";
    if (occurrence != -1) {
      urlWithoutQueryString = str.substring(0, occurrence);
    } else {
      urlWithoutQueryString = str;
    }
    return urlWithoutQueryString;
  } catch (e) {
    return "";
  }
};

const getHostFromRequestHeaders = (requestHeaders: any): string =>
  requestHeaders[customHeaders.DOMAIN_NAME] || DEFAULT_DOMAIN;

const getRequestProtocol = (requestHeaders: any): string =>
  requestHeaders[customHeaders.FORWARDED_PROTOTYPE] || DEFAULT_PROTO;

const canonicalBuilder = (url: string, req: any): string => {
  if (!url || !req) {
    return "";
  }
  return `${getRequestProtocol(req.headers)}://${getHostFromRequestHeaders(req.headers)}${url}`;
};

/**
 * fuction check single payment page eligibility on server side.
 */

 export const checkSinglePaymentPageEligibility = ({
   flow,
   availableFlowForSinglePaymentPage = [],
 }: {
   flow: string;
   availableFlowForSinglePaymentPage?: string[];
 }) => {
   try {
     if (availableFlowForSinglePaymentPage.includes(flow)) {
       return true;
     }
     return false;
   } catch (error) {
     return false;
   }
 };


export const getCanonicalFromRequest = (req: any): string => {
  if (!req) {
    return "";
  }
  try {
    const browserUrl = req.header(customHeaders.BROWSER_URL);
    let canonicalUrl = "";
    const canonicalUrlFromHeader = req.header(customHeaders.CANONICAL_URL);
    const xOriginalUrl = req.header(customHeaders.ORIGINAL_URL);
    const urlWithoutParams = req.originalUrl.split("?");
    if (canonicalUrlFromHeader) {
      canonicalUrl = canonicalUrlFromHeader;
    } else if (xOriginalUrl) {
      canonicalUrl = getUrlWithoutQueryString(xOriginalUrl);
    } else if (browserUrl) {
      canonicalUrl = browserUrl.split("?")[0];
    } else {
      canonicalUrl = canonicalBuilder(urlWithoutParams[0], req);
    }
    return canonicalUrl;
  } catch (error) {
    //TODO: log error
    return "";
  }
};

/**
 * Get device type from headers set on Akamai
 */
export const getDeviceTypeFromHeaders = (headers: any): string => {
  if (headers["cloudfront-is-mobile-viewer"] === "true") {
    return "mobile";
  } else {
    return "desktop";
  }
}

/**
 * req.query.eq may contain any value and that will be set as deviceType,
 * to avoid that we are only allowing mobile, desktop, tablet devices
 */
export const getEqParam = (eq: string) => {
  const MOBILE = "mobile";
  const DESKTOP = "desktop";
  const TABLET = "tablet";
  const GENERIC = "generic"; // for fashion
  const devices = [MOBILE, DESKTOP, TABLET, GENERIC];
  if (devices.indexOf(eq) === -1) {
    return "mobile";
  }
  // for fashion
  if (eq == GENERIC) {
    return "desktop";
  }
  return eq;
};

/**
 * req.query.eq may contain any value and that will be set as deviceType,
 * to avoid that we are only allowing mobile, desktop, tablet devices
 */

 export const getShimmerServerConfig = ({ url, remoteConfig }:any) => {
  /**
   * for new and saved payment options on single page.
   */
   let isSingleCheckoutPage = false;
   const availableFlowForSinglePaymentPage =
     remoteConfig?.configs?.payment?.availableFlowForSinglePaymentPage || [];

  let headerTitle = "Select Address & Pay";
  let hideShimmer = false;
  let height = "174px";
  let flow = "checkout";

  if (url.includes("paymentSuccess")) {
    headerTitle = "Confirmation";
    hideShimmer = true;
  } else if (url.includes("wallet")) {
    isSingleCheckoutPage = checkSinglePaymentPageEligibility({
      flow: PAYMENT_FLOWS.WALLET,
      availableFlowForSinglePaymentPage,
    });
    headerTitle = "Adding";
    hideShimmer = isSingleCheckoutPage;
    flow = "wallet";
  } else if (url.includes("giftcard")) {
    isSingleCheckoutPage = checkSinglePaymentPageEligibility({
      flow: PAYMENT_FLOWS.GIFT_CARD,
      availableFlowForSinglePaymentPage,
    });
    headerTitle = "Gift Card Payment";
    hideShimmer = isSingleCheckoutPage;
    flow = "giftcard";
  } else if (url.includes("codToPrepaidPayment")) {
    isSingleCheckoutPage = checkSinglePaymentPageEligibility({
      flow: PAYMENT_FLOWS.COD_TO_PREPAID,
      availableFlowForSinglePaymentPage,
    });
    headerTitle = "Pay Now";
    hideShimmer = isSingleCheckoutPage;
    flow = "giftcard";
  } else if (url.includes("/postPayment")) {
    headerTitle = "";
    hideShimmer = true;
  } else if (url.includes("paymentFailureOrderId")) {
    headerTitle = isSingleCheckoutPage ? "Pay" : "Select Address & Pay";
    hideShimmer = true;
  } else if (url.includes("/preConfirmation")) {
    headerTitle = "";
    hideShimmer = true;
  } else if (url.includes("/v2/payment")) {
    isSingleCheckoutPage = checkSinglePaymentPageEligibility({
      flow: PAYMENT_FLOWS.CHECKOUT,
      availableFlowForSinglePaymentPage,
    });
    headerTitle = isSingleCheckoutPage ? "Pay ₹0" : "Select Address & Pay";
    hideShimmer = isSingleCheckoutPage;
  } else if (url.includes("/v2/address/saved")) {
    headerTitle = "Saved Address";
    hideShimmer = false;
  } else if(url.includes("/v3/payment")){
    isSingleCheckoutPage = true
  }else {
    hideShimmer = true;
  }

  return { headerTitle, hideShimmer, height, isSingleCheckoutPage, flow };
};

/**
 * @description
 * It will return parsed json object
 * @param {Object} obj
 */
 export const fromJson = (obj:string):object | null => {
  try {
    return JSON.parse(obj);
  } catch (e) {
    return null;
  }
};

export const stringify = (obj:object): string | null => {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    return null;
  }
};
